/* eslint-env browser */
import React, { PropTypes, Component } from 'react';
import page from 'page';
import { scrollToDOMElement } from '../../utils/dom';

const selectHandler = event => {
  const value = event.target.value;
  page(value);
};

const getURL = route => {
  if (route === 'home') return '/resources';
  if (route === 'whitepapers') return '/resources/whitepapers';
  if (route === 'webinars') return '/resources/webinars';
  if (route === 'videos') return '/resources/videos';
  if (route === 'ebooks') return '/resources/ebooks';
  return '/';
};

class SearchBar extends Component {
  componentDidMount() {
    this.countHelper = 0;
  }

  componentWillReceiveProps() {
    this.countHelper += 1;
    if (this.countHelper > 1) {
      scrollToDOMElement(this.categoryContainer);
    }
  }

  render() {
    const { searchValue, onInputChange, route, firstTabIsSelected } = this.props;
    const selectValue = getURL(route);
    return (
      <div
        ref={el => {
          this.categoryContainer = el;
        }}
        className="category-bar-wrapper"
      >
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className="category-bar">
                <div className="categories-nav-holder hidden-xs hidden-sm">
                  {firstTabIsSelected
                    ? <ul className="nav nav-categories nav-center nav-tabs">
                        <li className="category active link-disabled-utils" data-category="all">
                          <a href="/resources">All</a>
                        </li>
                        <li className="category" data-category="all">
                          <a href="/resources/whitepapers">Whitepapers</a>
                        </li>
                        <li className="category" data-category="all">
                          <a href="/resources/webinars">Webinars</a>
                        </li>
                        <li className="category" data-category="all">
                          <a href="/resources/ebooks">Ebooks</a>
                        </li>
                        <li className="category" data-category="all">
                          <a href="/resources/videos">Videos</a>
                        </li>
                      </ul>
                    : <ul className="nav nav-categories nav-center nav-tabs">
                        <li
                          className={
                            route === 'home' ? 'category active link-disabled-utils' : 'category'
                          }
                          data-category="all"
                        >
                          <a href="/resources">All</a>
                        </li>
                        <li
                          className={
                            route === 'whitepapers'
                              ? 'category active link-disabled-utils'
                              : 'category'
                          }
                          data-category="all"
                        >
                          <a href="/resources/whitepapers">Whitepapers</a>
                        </li>
                        <li
                          className={
                            route === 'webinars'
                              ? 'category active link-disabled-utils'
                              : 'category'
                          }
                          data-category="all"
                        >
                          <a href="/resources/webinars">Webinars</a>
                        </li>
                        <li
                          className={
                            route === 'ebooks' ? 'category active link-disabled-utils' : 'category'
                          }
                          data-category="all"
                        >
                          <a href="/resources/ebooks">Ebooks</a>
                        </li>
                        <li
                          className={
                            route === 'videos' ? 'category active link-disabled-utils' : 'category'
                          }
                          data-category="all"
                        >
                          <a href="/resources/videos">Videos</a>
                        </li>
                      </ul>}
                </div>
                <form className="category-form form-horizontal hidden-md hidden-lg">
                  <div className="form-group">
                    <div className="col-xs-12 text-center">
                      <div className="dropdrown-wrapper">
                        <select
                          onChange={selectHandler}
                          className="form-control"
                          defaultValue={selectValue}
                        >
                          <option value="/resources">All Categories</option>
                          <option value="/resources/whitepapers">Whitepapers</option>
                          <option value="/resources/webinars">Webinars</option>
                          <option value="/resources/videos">Videos</option>
                          <option value="/resources/ebooks">Ebooks</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </form>
                <form className="search-form">
                  <div className="form-group search-control">
                    <i className="icon-budicon-489" />
                    <input
                      onChange={onInputChange}
                      type="text"
                      placeholder="Search for resources"
                      id="search-input"
                      className="search-input form-control"
                      value={searchValue}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SearchBar.defaultProps = {
  route: null
};

SearchBar.propTypes = {
  onInputChange: PropTypes.func.isRequired,
  route: PropTypes.string,
  firstTabIsSelected: PropTypes.bool.isRequired,
  searchValue: PropTypes.string.isRequired
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/pages/resources/components/SearchBar/SearchBar.js